export default __webpack_public_path__ + "static/media/soon.00ce27f1.svg";